import { useEffect, useState, type ReactNode } from "react";
import { LazyRoute, defaultLazyRouteFallback } from "./lazy-route";

export interface ClientOnlyRouteProps {
	children: ReactNode;
	fallback?: ReactNode;
}

/**
 * Keeps browser-only routes out of SSR while preserving identical server and
 * initial client markup for hydration. Also provides the Suspense boundary
 * required by React.lazy() children.
 */
export const ClientOnlyRoute = ({
	children,
	fallback = defaultLazyRouteFallback,
}: ClientOnlyRouteProps) => {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return <>{fallback}</>;
	}

	return <LazyRoute fallback={fallback}>{children}</LazyRoute>;
};
